module.exports = __webpack_public_path__ + "img/main.0fce1538.jpg";